/**
 * Server-tick clock estimation from snapshot arrivals (EWMA). Remote cars are
 * no longer interpolated in the past — the whole world is predicted at the
 * local present (see prediction.ts) — but the countdown still needs a live
 * estimate of the CURRENT server tick to release the controls exactly at GO.
 */

import { TICK_RATE } from '@microligue/shared';

const TICK_MS = 1000 / TICK_RATE;

/** Estimates the current server tick from snapshot arrival times. */
export class ServerClock {
  private offsetTicks: number | null = null;

  onSnapshot(tick: number): void {
    const localTicks = performance.now() / TICK_MS;
    const offset = tick - localTicks;
    // Bias toward the highest observed offset (fastest path), converge slowly.
    if (this.offsetTicks === null || offset > this.offsetTicks) {
      this.offsetTicks = offset;
    } else {
      this.offsetTicks = this.offsetTicks * 0.995 + offset * 0.005;
    }
  }

  /** Estimated CURRENT server tick (no interpolation delay) — drives the GO. */
  serverTick(): number | null {
    if (this.offsetTicks === null) return null;
    return performance.now() / TICK_MS + this.offsetTicks;
  }
}
